/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '700',
    gap: 8,
    hintColor: '#414547',
    hintFontName: 'HNforTELUSSA',
    hintFontSize: 14,
    hintFontWeight: '400',
    hintLineHeight: 1.42857142857,
    lineHeight: 1.5
  }
}
export default theme
